module.exports = __webpack_public_path__ + "static/media/47.03c450a2.png";